export default {
    goodsBrand: {
        page: {
            Status: '状态',
            AddBrand: '新增品牌',
            uploadedSize: '您上传的LOGO图片大小超过50KB，请重新选择',
            uploadedTip: '建议尺寸：800*800像素，只能上传jpg/png/gif格式文件，文件不能超过50KB',
            PleaseBrand: '请输入品牌名称',
            EditBrand: '编辑品牌',
            CreateBrand: '新建品牌'
        },
        table: {
            name: '品牌名称',
            code: '品牌编码',
            LOGO: '品牌LOGO',
            Manufacturer: '生产商',
            Operator: '操作人员',
        }
    }
};
